<template>
  <div @keypress="submit">
    <div style="margin-left: 20px;">
      <div style="display: flex; text-align: center" class="  testoblu">
        <div style="width: 66%">{{ S0012 }}</div>
        <div style="width: 30%">{{ S0013 }}</div>
      </div>
      <div style="display: flex" class="  testoblu">
        <div style="width: 75%"></div>
        <div style="width: 10%">{{ S0014 }}</div>
        <div style="width: 10%">{{ S0015 }}</div>
      </div>

      <div style="display: flex; flex-direction: column;">
        <ComponentList v-for="(item, index) in items" :key="index" :lang="lang" :itemData="item" :index="index"
          :foodComponents="foodComponents" @changedValue="onChangeComponentValue"></ComponentList>
      </div>
      <br />

      <div style="margin-right: 3px; margin-top: -2px; text-align: center;" class="testoblu">{{ S0019 }}
      </div>
      <br />

      <div style="display: flex; flex-direction: column;">
        <CategoryList v-for="(item, index) in groupitems" :key="index" :lang="lang" :itemData="item" :index="index"
          :foodCategories="foodCategories" @changedValue="onChangeCategoryValue" @removeitem="onRemoveitem">
        </CategoryList>
        <div style="display: flex; flex-direction: row;" @click="addCategory()">
          <div style="margin-top: 10px; cursor: pointer;"><img src="../assets/add.png" /></div>
          <div style="margin-top: 10px; cursor: pointer;margin-left: 10px;">{{ S0020 }}</div>
        </div>

      </div>
    </div>
    <br />
    <div>
      <div class="testonormale" style="text-align: center">
        <span style="margin-right: 3px;">{{ S0016 }}</span>
        <span style="margin-right: 3px; font-weight: bold; text-decoration: underline; text-transform: uppercase;">{{ S0017 }}</span>
        <span style="margin-right: 3px; ">{{ S0018 }}</span>
        <span style="margin-right: 3px;"><input type="checkbox" v-model="reverse" /></span>        
      </div>
    </div>
    <br />
    <br />
    <div class="centerElement">
      <div>
        <button @click="raiseSearch" style="margin-right: 5px">{{ BTNSEARCH }}</button>
        <button @click="clearFilter">{{ BTNCLEAR }}</button>
      </div>
    </div>
    <div style="margin-top: 10px;" v-if="showError" class="centerElement titolorosso">{{ SELPARS }}</div>
  </div>
</template>

<script>
import api from "../js/apiConsts.js";
import { axiosPost } from "../js/apiService.js";
import apiConsts from "../js/apiConsts.js";
import { getSTRING } from "@/js/utils";
import ComponentList from "./ComponentList.vue";
import CategoryList from './CategoryList.vue';
export default {
  name: "SearchCategoryComponent",
  components: {
    ComponentList,
    CategoryList
  },
  props: ["lang"],
  emits: { search: null, clear: null, error: null, clearResult: null },
  data() {
    return {
      language: this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      showError: false,
      reverse: false,
      items: [
        {
          componentId: "",
          minValue: null,
          maxValue: null,
        },
        {
          componentId: "",
          minValue: null,
          maxValue: null,
        },
        {
          componentId: "",
          minValue: null,
          maxValue: null,
        },
      ],
      groupitems: [
        {
          foodCategory: ""
        },
        {
          foodCategory: ""
        },
        {
          foodCategory: ""
        },
      ],
      foodComponents: null,
      foodCategories: null,
      S0012: '',
      S0013: '',
      S0014: '',
      S0015: '',
      S0016: '',
      S0017: '',
      S0018: '',
      S0019: '',
      S0020: '',
      S0021: '',
      SELPARS: '',
      BTNSEARCH: '',
      BTNCLEAR: '',
      TITOLO: ''
    };
  },
  async mounted() {
    this.S0012 = getSTRING(this.lang, "S0012", "Componente");
    this.S0013 = getSTRING(this.lang, "S0013", "Range");
    this.S0014 = getSTRING(this.lang, "S0014", "min");
    this.S0015 = getSTRING(this.lang, "S0015", "max");
    this.S0016 = getSTRING(this.lang, "S0016", "Ricerca solo gli alimenti che");
    this.S0017 = getSTRING(this.lang, "S0017", "non");
    this.S0018 = getSTRING(this.lang, "S0018", "contengono i componenti");
    this.S0019 = getSTRING(this.lang, "S0019", "Restringi la ricerca alle seguenti categorie merceologiche")
    this.S0020 = getSTRING(this.lang, "S0020", "Aggiungi categoria")
    this.S0021 = getSTRING(this.lang, "S0021", "Rimuovi categoria")
    this.SELPARS = getSTRING(this.lang, "SELPARS", "Selezionare almeno un parametro");
    this.BTNSEARCH = getSTRING(this.lang, "BTNSEARCH", "Cerca");
    this.BTNCLEAR = getSTRING(this.lang, "BTNCLEAR", "Pulisci");
    this.TITOLO = getSTRING(this.lang, "TITOLO", apiConsts.TITOLOAPP);
    await this.loadFoodComponentsInfo();
    await this.loadFoodCategoriesInfo();
  },
  methods: {
    submit(e) {
      if (e.keyCode === 13) {
        this.raiseSearch()
      }
    },
    onChangeComponentValue(value, index) {
      if (isNaN(parseInt(value.minValue))) {
        value.minValue = null;
      }
      if (isNaN(parseInt(value.maxValue))) {
        value.maxValue = null;
      }
      this.items[index] = value;
    },
    onChangeCategoryValue(value, index) {
      this.groupitems[index] = value;
    },
    clearFilter() {
      this.items[0] = {
        componentId: "",
        minValue: null,
        maxValue: null,
      };
      this.items[1] = {
        componentId: "",
        minValue: null,
        maxValue: null,
      };
      this.items[2] = {
        componentId: "",
        minValue: null,
        maxValue: null,
      };
      this.groupitems = [];
      this.groupitems[0] = {
        foodCategory: ""
      };
      this.groupitems[1] = {
        foodCategory: ""
      };
      this.groupitems[2] = {
        foodCategory: ""
      };
      this.showError = false;
      this.$emit("clear");
    },
    raiseSearch() {
      let elementToSearch = this.items.slice().filter(f => f.componentId != "");
      let categoryToSearch = this.groupitems.slice().filter(f => f.foodCategory != "");
      if (elementToSearch.length > 0) {
        this.showError = false;
        this.$emit("search", this.reverse, elementToSearch, categoryToSearch)
      }
      else {
        this.showError = true;
        this.$emit("clearResult")
      }
    },
    onRemoveitem(index) {
      this.groupitems.splice(index, 1);
    },
    async loadFoodCategoriesInfo() {
      let clanguage = this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1;
      await axiosPost(api.APIFoodCategoriesSearch, {
        language: clanguage,
      })
        .then((response) => {
          let res = response.data;
          this.foodCategories = null;
          if (res.success) {
            this.foodCategories = res.elements;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.$emit('error', err.message);
        });
    },
    async loadFoodComponentsInfo() {
      let clanguage = this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1;
      await axiosPost(api.APIComponents, {
        language: clanguage,
      })
        .then((response) => {
          let res = response.data;
          this.foodComponents = null;
          if (res.success) {
            this.foodComponents = res.components;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.$emit('error', err.message);
        });
    },
    addCategory() {
      let item = {
        foodCategory: ""
      }

      this.groupitems.push(item);
    }
  },
};
</script>
